import { createListenerMiddleware } from "@reduxjs/toolkit";
import { addAuthListener } from "@/entities/session";
import { addAnnotationLocalStorageListeners } from "@/entities/annotation/model";

export const listenerMiddleware = createListenerMiddleware();

export type AppStartListening = typeof listenerMiddleware.startListening;

addAuthListener(listenerMiddleware.startListening);
addAnnotationLocalStorageListeners(listenerMiddleware.startListening);
